export default class Pagination {
    private readonly formId = 'tx_indexedsearch';
    private readonly pointerId = 'tx_indexedsearch_pointer';
    private readonly freeIndexUidId = 'tx_indexedsearch_freeIndexUid';
    private readonly waiting = 'waiting';

    private readonly form: HTMLFormElement | null;
    private readonly pointer: string | null;
    private readonly freeIndexUid: string | null;

    private wrapper: HTMLElement | null = null;
    private query = '';

    constructor() {
        this.form = document.querySelector<HTMLFormElement>(`#${this.formId}`);
        this.pointer = document.querySelector<HTMLInputElement>(`#${this.pointerId}`)?.name ?? null;
        this.freeIndexUid = document.querySelector<HTMLInputElement>(`#${this.freeIndexUidId}`)?.name ?? null;
    }

    private renderResponse(response: string): void {
        if (!this.wrapper) {
            return;
        }

        const doc = new DOMParser().parseFromString(response, 'text/html');
        const responseWrapper = doc.querySelector(this.query);
        if (responseWrapper) {
            this.wrapper.innerHTML = responseWrapper.innerHTML;
            window.scrollTo({top: 0, behavior: 'smooth'});
        }
    }

    private navigate(pointer: number, freeIndexUid: string): void {
        const wrapper = this.wrapper;
        if (!this.form || !wrapper || this.pointer === null || this.freeIndexUid === null) {
            return;
        }

        const body = new FormData(this.form);
        body.append(this.pointer, `${pointer}`);
        body.append(this.freeIndexUid, freeIndexUid);

        const addWaitingClass = setTimeout(() => {
            wrapper.classList.add(this.waiting);
        }, 500);

        fetch(this.form.action, {method: this.form.method, body})
            .then(response => response.text())
            .then(response => {
                clearTimeout(addWaitingClass);
                wrapper.classList.remove(this.waiting);
                this.renderResponse(response);
            });
    }

    private get navigators(): HTMLElement[] {
        return Array.from(this.wrapper?.querySelectorAll<HTMLElement>('[data-page][data-free-index-uid]') ?? []);
    }

    private registerPageHandler(): void {
        this.wrapper?.addEventListener('click', event => {
            const target = event.target;
            if (!(target instanceof HTMLElement) || !this.navigators.includes(target)) {
                return;
            }

            event.preventDefault();
            const {page, freeIndexUid} = target.dataset;
            if (page === undefined || freeIndexUid === undefined) {
                return;
            }

            this.navigate(Number.parseInt(page, 10), freeIndexUid);
        });
    }

    public registerPagination(wrapperQuery: string): void {
        this.query = wrapperQuery;
        this.wrapper = document.querySelector<HTMLElement>(wrapperQuery);
        this.registerPageHandler();
    }
}
